import type { AnalyticsContext } from "./analytics";

export type LeaderboardRow = { name: string | null; rank: number | null; carats: string; isSelf: boolean };
export type SeasonLeaderboard = {
  seasonId: string | null;
  calculatedAt: string;
  participantCount: number;
  leaders: LeaderboardRow[];
  self: LeaderboardRow | null;
};
export type SupportRequest = { requestId: string; message: string; screen: string; context: AnalyticsContext };
export type SupportReceipt = { reference: string; receivedAt: string };
export type SupportTicketSummary = { reference: string; status: string; createdAt: string; updatedAt: string; unread: boolean; preview: string };
export type SupportInbox = { tickets: SupportTicketSummary[]; next: string | null };
export type SupportThread = { reference: string; status: string; updatedAt: string; canReply?: boolean;
  messages: { id: string; author: "player" | "support"; body: string; createdAt: string }[] };

export function browserDiagnosticsContext(): AnalyticsContext {
  const platform = document.documentElement.dataset.platform;
  const version: unknown = import.meta.env.VITE_APP_VERSION;
  return { clientVersion: typeof version === "string" && version ? version : "local",
    platform: platform === "ios" || platform === "android" || platform === "desktop" ? platform : "unknown",
    locale: document.documentElement.lang === "en" ? "en" : "ru" };
}
